import React from 'react';

/**
 * Strips HTML tags from a string for plain-text previews (e.g. card snippets)
 */
export const stripHtml = (html) => {
  if (!html) return '';
  if (typeof html !== 'string') return String(html);
  
  // Fast regex to remove tags and clean up spacing
  return html
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim();
};

/**
 * Checks if a string contains valid HTML tags
 */
export const isHtmlContent = (str) => {
  if (!str || typeof str !== 'string') return false;
  return /<[a-z][\s\S]*>/i.test(str);
};

/**
 * RichTextViewer safely renders formatted HTML content or fallback plain text
 */
const RichTextViewer = ({ content, className = '' }) => {
  if (!content) return null;

  if (isHtmlContent(content)) {
    return (
      <div
        className={`rich-text-content text-sm text-gray-800 leading-relaxed
          [&_p]:mb-2.5 [&_p:last-child]:mb-0
          [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-2
          [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:my-2
          [&_li]:my-1
          [&_h1]:text-xl [&_h1]:font-bold [&_h1]:text-gray-900 [&_h1]:mt-3 [&_h1]:mb-1.5
          [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:mt-2.5 [&_h2]:mb-1
          [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-gray-900 [&_h3]:mt-2 [&_h3]:mb-1
          [&_blockquote]:border-l-4 [&_blockquote]:border-[#2C5F7F]/40 [&_blockquote]:pl-3.5 [&_blockquote]:my-2.5 [&_blockquote]:italic [&_blockquote]:text-gray-600
          [&_a]:text-[#2C5F7F] [&_a]:underline [&_a]:font-medium hover:[&_a]:text-[#1e4157]
          [&_strong]:font-bold [&_b]:font-bold
          [&_u]:underline
          [&_s]:line-through [&_strike]:line-through
          ${className}`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  // Fallback for legacy plain text announcements
  return (
    <div className={`text-sm text-gray-800 whitespace-pre-wrap leading-relaxed ${className}`}>
      {content}
    </div>
  );
};

export default RichTextViewer;
